export { sendEvent } from 'next-flight-server-reference-proxy-loader?id=7fb8ebe1698fcd4014220c9b73d1696c60db3c10d4&name=sendEvent!'